// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import "./EditAlumni.css";

// function EditAlumni() {
//   const navigate = useNavigate(); // ✅ Initialize navigation
//   const [formData, setFormData] = useState({
//     photo: null,
//     phoneNumber: "",
//     countryCode: "+91", // Default to India
//     currentCompany: "",
//     jobTitle: "",
//     workExperience: "",
//   });



//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (!token) {
//           alert("Unauthorized! Redirecting to login.");
//           navigate("/login");
//           return;
//         }

//         const response = await axios.get("http://localhost:5002/api/auth/profile/alumni", {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         if (response.data) {
//           setFormData((prevData) => ({
//             ...prevData,
            
//             currentCompany: response.data.currentCompany || "",
//             jobTitle: response.data.jobTitle || "",
//             workExperience: response.data.workExperience || "",
//           }));
//         }
//       } catch (error) {
//         console.error("❌ Access Denied!", error);
//         navigate("/login");
//       }
//     };

//     fetchUserData();
//   }, [navigate]);

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (name === "photo" && files) {
//       const file = files[0];
//       if (file.size > 5 * 1024 * 1024) {
//         alert("File size exceeds 5 MB. Please upload a smaller file.");
//         return;
//       }
//       setFormData((prevData) => ({
//         ...prevData,
//         photo: file,
//       }));
//     } else {
//       setFormData((prevData) => ({
//         ...prevData,
//         [name]: value,
//       }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.photo) {
//       alert("Please upload a photo!");
//       return;
//     }

//     try {
//       const token = localStorage.getItem("token");
//       const formDataToSend = new FormData();
//       for (const key in formData) {
//         formDataToSend.append(key, formData[key]);
//       }

//       await axios.post("http://localhost:5002/api/auth/update/alumni", formDataToSend, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       alert("✅ Profile updated successfully!");
//     } catch (error) {
//       console.error("❌ Failed to update profile", error);
//       alert("Error updating profile");
//     }
//   };

//   const photoPreview = formData.photo ? URL.createObjectURL(formData.photo) : null;

//   return (
//     <div className="edit-alumni">
//       <div className="form-container">
//         <h1>Edit Alumni Form</h1>
//         <form onSubmit={handleSubmit}>
//           {/* Photo Upload */}
//           <div className="form-group">
//             <div className="photo-placeholder">
//               {photoPreview ? (
//                 <img src={photoPreview} alt="Profile Preview" />
//               ) : (
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 24 24"
//                   fill="gray"
//                   width="50%"
//                   height="50%"
//                 >
//                   <circle cx="12" cy="8" r="4" />
//                   <path d="M2 20c0-5.33 4.33-8 10-8s10 2.67 10 8H2z" />
//                 </svg>
//               )}
//             </div>
//             <div className="photo-options">
//               <label htmlFor="photo-upload" className="upload-btn">Upload Photo</label>
//               <input type="file" id="photo-upload" name="photo" accept="image/*" onChange={handleChange} />
//             </div>
//           </div>

        

//           {/* Current Company */}
//           <div className="form-group">
//             <label>Current Company:</label>
//             <input type="text" name="currentCompany" value={formData.currentCompany} onChange={handleChange} />
//           </div>

//           {/* Job Title */}
//           <div className="form-group">
//             <label>Job Title:</label>
//             <input type="text" name="jobTitle" value={formData.jobTitle} onChange={handleChange} />
//           </div>

//           {/* Work Experience */}
//           <div className="form-group">
//             <label>Work Experience:</label>
//             <textarea name="workExperience" value={formData.workExperience} onChange={handleChange} />
//           </div>

//           <button type="submit">Save changes</button>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default EditAlumni;


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAlumniProfile, updateAlumniProfile } from "../../api/alumniApi";
import "./EditAlumni.css";

function EditAlumni() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    photo: null,
    profileImageUrl: "",
    currentCompany: "",
    jobTitle: "",
    workExperience: "",
    firstName: "",
    lastName: "",
    email: "",
  });

  // ✅ Fetch Alumni Profile on Component Mount
  // ✅ Fetch Alumni Profile on Component Mount
useEffect(() => {
  const fetchProfile = async () => {
    try {
      const data = await fetchAlumniProfile(); // ✅ Fetch alumni details
      console.log("📢 Received Alumni Data:", data);

      if (!data) {
        console.error("❌ Error: Alumni data is empty");
        return;
      }

      // ✅ Ensure data is correctly populated
      setFormData({
        profileImageUrl: data.profileImageUrl || "",
        currentCompany: data.currentCompany || "",
        jobTitle: data.jobTitle || "",
        workExperience: data.workExperience || "",
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        email: data.email || "",
      });
    } catch (error) {
      console.error("❌ Error Fetching Alumni Profile", error);
      alert("Error fetching profile. Please try logging in again.");
      navigate("/login");
    }
  };

  fetchProfile();
}, [navigate]);

  // ✅ Handle File Upload
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "photo" && files) {
      const file = files[0];
      if (file.size > 5 * 1024 * 1024) {
        alert("File size exceeds 5 MB. Please upload a smaller file.");
        return;
      }
      setFormData((prevData) => ({
        ...prevData,
        photo: file,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // ✅ Handle Profile Update
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log("📢 Submitting profile update:", formData);
      const response = await updateAlumniProfile(formData);

      alert("✅ Profile updated successfully!");
      setFormData((prevData) => ({
        ...prevData,
        profileImageUrl: response.profileImageUrl || prevData.profileImageUrl,
      }));
    } catch (error) {
      console.error("❌ Failed to update profile", error);
      alert("Error updating profile");
    }
  };

  // ✅ Show Preview or Existing Image
  const photoPreview = formData.photo
    ? URL.createObjectURL(formData.photo)
    : formData.profileImageUrl;

  return (
    <div className="edit-alumni">
      <div className="form-container">
        <h1>Edit Alumni Profile</h1>
        <form onSubmit={handleSubmit}>


          {/* Photo Upload */}
<div className="form-group">
  <div className="photo-placeholder">
    {photoPreview ? (
      <img src={photoPreview} alt="Profile Preview" />
    ) : (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="gray" width="50%" height="50%">
        <circle cx="12" cy="8" r="4" />
        <path d="M2 20c0-5.33 4.33-8 10-8s10 2.67 10 8H2z" />
      </svg>
    )}
  </div>
  <div className="photo-options">
  {/* Upload Button */}
  <label htmlFor="photo-upload" className="upload-btn">
    Upload Photo
  </label>
  <input 
    type="file" 
    id="photo-upload" 
    name="photo" 
    accept="image/*" 
    onChange={handleChange} 
    style={{ display: "none" }} 
  />

  {/* Cancel Button */}
  <button 
    type="button" 
    className={`cancel-btn ${formData.photo ? 'show' : ''}`} 
    onClick={() => setFormData({ ...formData, photo: null })}
  >
    Remove
  </button>
</div>
</div>


          

          {/* First Name */}
          <div className="form-group">
            <label>First Name:</label>
            <input type="text" name="firstName" value={formData.firstName} disabled />
          </div>

          {/* Last Name */}
          <div className="form-group">
            <label>Last Name:</label>
            <input type="text" name="lastName" value={formData.lastName} disabled />
          </div>

          {/* Current Company */}
          <div className="form-group">
            <label>Current Company:</label>
            <input type="text" name="currentCompany" value={formData.currentCompany} onChange={handleChange} />
          </div>

          {/* Job Title */}
          <div className="form-group">
            <label>Job Title:</label>
            <input type="text" name="jobTitle" value={formData.jobTitle} onChange={handleChange} />
          </div>

          {/* Work Experience */}
          <div className="form-group">
            <label>Work Experience:</label>
            <textarea name="workExperience" value={formData.workExperience} onChange={handleChange} />
          </div>

          
          <button type="submit" className="submit-button">Save changes</button>
          
        </form>
      </div>
    </div>
  );
}

export default EditAlumni;